<template>
  <!-- SPID HEADER * begin * -->
  <header class="ic1-header-wrapper" v-if="agid">
    <div class="ic1-header">
      <div class="ic1-header-info">
        <img src="https://assets.infocert.it/logos/brands/infocert/default.svg" aria-hidden="true" alt="Infocert ID" width="70" height="auto">
        <div class="ic1-divider"></div>
        <h1 class="ic1-header-title">{{ APP_NAME }}</h1>
      </div>
    </div>
  </header>
  <!-- SPID HEADER * end * -->

  <!-- SPID HEADER * begin * -->
  <div v-else id="header">
    <div id="header-inner">
      <img aria-hidden="true" id="idp-logo" :src="logo" alt="Logo" v-if="agid" />
      <img aria-hidden="true" class="logo_spid" :src="logo_fs" alt="Logo_SPID" v-if="!agid" />
      <img aria-hidden="true" class="logo_tim" :src="logo_sn" alt="Logo_TIM" v-if="!agid" />
      <img aria-hidden="true" class="logo_trust" :src="logo_td" alt="Logo_TRUST" v-if="!agid" />
    </div>
  </div>
  <!-- SPID HEADER * end * -->

  <div v-if="agid" class="ic1-container ic1-bg-primary">
    <div class="ic1-row">
      <div class="ic1-col-md-12 ic1-col-12 ic1-centered"><img aria-hidden="true" class="img-logo-spid" src="/img/spid-logo.svg"
          onerror="this.onerror=null; this.src='img/spid-logo.png'" alt="logo-spid" /></div>
      <div class="ic1-col-md-12 ic1-col-12 ic1-no-up-padding ic1-centered" v-if="spidLevel">
        <h2 class="ic1-text-pretitle" style="color:white">{{ spName }}</h2>
      </div>
    </div>

    <!-- SPID LOGIN FORM * begin * -->
    <router-view @error="handleErrorEvent" @logged="handleMessageEvent('', $event)" />
    <!-- SPID LOGIN FORM * end * -->
  </div>

  <div v-else id="outer">
    <div id="contain-all">
      <div class="inner">
        <div class="grid spacer-top-1" v-if="spidLevel">
          <div class="width-one-whole spid-logo"><img aria-hidden="true" :src="getImgUrl()" alt="logo" /></div>
        </div>
        <div class="grid spacer-top-1" v-if="spidLevel">
          <div class="width-one-whole pa-title">{{ spName }}</div>
        </div>
        <div class="grid spacer-top-1" v-if="spidLevel">
          <div class="width-one-whole"><span class="spid-hr"></span></div>
        </div>
        <div class="grid">
          <div class="width-one-whole">

            <!-- ERROR -->
            <div class="alert alert-error" role="alert" v-show="error && errorTypeDanger">
              <div class="alert-body">
                <h3 class="alert-heading" data-i18n="basicauth.label_error">
                  Errore!
                </h3>
                <p class="alert-text" data-i18n="[html]credential_state.INVALID" data-i18n-options='{ "url": "" }'>
                  {{ errorCode }}
                </p>
                 <p v-html="errorMessageDes" class="alert-text" data-i18n="[html]credential_state.INVALID" data-i18n-options='{ "url": "" }'>
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- SPID LOGIN FORM * begin * -->
        <router-view @error="handleErrorEvent" @logged="handleMessageEvent('', $event)" />
        <!-- SPID LOGIN FORM * end * -->

      </div>
    </div>
  </div>

  <!-- SPID FOOTER * begin * -->
  <div v-if="agid" class="ic1-footer-wrapper ">
    <div class="ic1-footer ">
      <div class="ic1-row">
        <div class="ic1-col-md-12 ic1-centered footer-color">
          <a href="http://www.spid.gov.it/check" target="blank_"><img aria-hidden="true" id="spid-agid-logo"
              src="img/spid-agid-logo-bb.svg" onerror="this.src='img/spid-agid-logo-bb.png'; this.onerror=null;"
              alt="SPID - AgID Agenzia per l'Italia Digitale - Check" /></a>
        </div>
      </div>
    </div>
  </div>
  <!-- SPID FOOTER * end * -->

  <!-- SPID FOOTER * begin * -->
  <div v-else id="footer">
    <div id="footer-inner">
      <a v-if="agid" href="http://www.spid.gov.it/check" target="blank_"><img aria-hidden="true" id="spid-agid-logo"
          src="img/spid-agid-logo-bb.svg" onerror="this.src='img/spid-agid-logo-bb.png'; this.onerror=null;"
          alt="SPID - AgID Agenzia per l'Italia Digitale - Check" /></a>
      <div v-else id="footer-custom">
        <div id="section1">TI Trust Technologies Srl con unico socio - C.F. P. IVA e Iscriz. Reg. Imp. Roma n.
          04599340967 - REA n. 1085826
        </div>
        <div id="section2">
          <ul id="footer-link">
            <li><a :href="$env.VUE_APP_WEBSITE_CONTACT_URL">Contatti</a></li>
            <li><a :href="$env.VUE_APP_WEBSITE_PRIVACY_URL">Privacy</a></li>
            <li><a :href="$env.VUE_APP_WEBSITE_ABOUT_URL">Chi Siamo</a></li>
            <li><a :href="$env.VUE_APP_WEBSITE_SPID_URL">SPID</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <!-- SPID FOOTER * end * -->
</template>

<script>
import { useI18n } from "vue-i18n";
import AuthService from "@/services/auth.service";
import store from "@/store";
import { ref } from "vue";
import '../node_modules/@infocert/ui-kit/dist/script.min.js';
import { createCookie, getCookie } from "./utils/useCookie";


export default {
  name: 'App',
  props: ['application'],

  data: function () {
    return {
      value: 7,
      error: false,
      errorCode: null,
      errorMessageDes: null,
      retries: 4,
      info: null,
      spidLevel: null,
      spProfile: null,
      spName: null,
      APP_NAME: null,
      APP_SAML_URL: null,
      classes: {
        "ic1-header-logo-new": true,
        "ic1-header-logo-custom": false,
      },
      reset_password_url: this.$env.VUE_APP_RESET_PASSWORD_URL,
    }
  },
  setup() {
    // context has attrs, slots, and emit()
    const { t, locale } = useI18n()
    const count = ref(0)
    return { count, t, locale }
  },


  mounted() {
    this.setIdTab();

    this.APP_NAME = this.$env.VUE_APP_NAME
    this.APP_SAML_URL = this.$env.VUE_APP_SAML_URL
    this.transactionId = getCookie('transactionId')
    this.spidLevel = getCookie('spidLevel', window.name)
    this.spName = getCookie('spName', window.name)
    this.spProfile = getCookie('spProfile', window.name);

    this.checkRedirect();
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },

    getErrorCode() {
      return store.getters.getErrorCode;
    },
    getErrorArgs() {
      return store.getters.getErrorArgs;
    },
    logo() {
      return process.env.VUE_APP_SUB_PATH + "/img/idp-logo.png";
    },
    logo_fs() {
      return process.env.VUE_APP_SUB_PATH + "/img/logoSPID.png";
    },
    logo_sn() {
      return process.env.VUE_APP_SUB_PATH + "/img/Timid_Positivo_DEF.png";
    },
    logo_td() {
      return process.env.VUE_APP_SUB_PATH + "/img/logo_trust.png";
    },
    agid() {
      return process.env.VUE_APP_SUB_PATH !== "tim";
    },
    errorTypeDanger() {
      return store.getters.getErrorType === 'danger';
    }
  },
  watch: {
    getErrorCode(newErrorCode) {
      if (newErrorCode) {
        this.error = true;
        this.errorCode = this.t(newErrorCode.errorCode, this.getErrorArgs || {}, { locale: this.locale });
        this.errorMessageDes = this.t(
          newErrorCode.errorArgs || '',
          {
            ...(this.getErrorArgs || {}),
            reset_password_url: this.reset_password_url,
          },
          { locale: this.locale }
        );
      }
    }
  },
  methods: {
    setIdTab() {
      window.name = new Date().getTime();
    },
    checkRedirect() {
      if (this.transactionId) {
        this.requestData(this.transactionId);
      } else {
        const url = window.location.search;
        const error = new URLSearchParams(url).get("errorCode");

        if (error === null) {
          const allowedRedirects = ['https://www.identitadigitale.infocert.it'];
          const redirectTo = this.$env.VUE_APP_WEBSITE_URL;
          if (allowedRedirects.includes(redirectTo)) {
            window.location.href = this.$env.VUE_APP_WEBSITE_URL;
          } else {
            console.error("Redirect URL not allowed: " + redirectTo);
          }
        }
      }
    },
    getImgUrl() {
      return 'img/spid-level' + this.spidLevel + '-logo-bb.svg';

    },

    setLogo(path) {
      if (path && path.length > 0) {
        this.$refs.logo.style.backgroundImage = "url('/" + path + "img/logo.png')"
        this.$refs.logo.style.backgroundSize = "contain";
        this.classes["ic1-header-logo-custom"] = true
        this.classes["ic1-header-logo-new"] = false
      }
    },
    requestData(transactionId) {

      AuthService.requestData(transactionId).then(response => {
        console.log("App response request data:" + JSON.stringify(response));
        console.log("App response response data:" + response.data);

        this.spName = response.data.serviceProvider;
        this.spidLevel = response.data.spidLevel;

        this.spProfile = response.data.profile || "";
        if (this.spProfile) {
          this.setLogo(this.spProfile)
        }


        this.setSpName(this.spName);
        this.setSpidLevel(this.spidLevel);
        this.setProfile(response.data.profile);

        createCookie('spName', this.spName);
        createCookie('spidLevel', this.spidLevel);
        createCookie('spProfile', this.spProfile);

        if (this.spName === null) {
         const allowedRedirects = ['https://www.identitadigitale.infocert.it'];
          const redirectTo = this.$env.VUE_APP_WEBSITE_URL;
          if (allowedRedirects.includes(redirectTo)) {
            window.location.href = this.$env.VUE_APP_WEBSITE_URL;
          } else {
            console.error("Redirect URL not allowed: " + redirectTo);
          }
        }
      })
        .catch(error => {
          console.log("AuthService.requestData(transactionId) ERROR: " + JSON.stringify(error));
          /**
           500 internal server error
           400 bad request
           403 forbidden
           xxx
           */
          const expr = error.response.status;

          // Controlla se siamo già in una pagina di errore per evitare loop
          const urlParams = new URLSearchParams(window.location.search);
          const currentErrorCode = urlParams.get("errorCode");

          if (currentErrorCode) {
            // Siamo già in una pagina di errore, non fare redirect per evitare loop
            console.log("Già in pagina di errore, evito redirect per prevenire loop");
            return;
          }

          switch (expr) {
            case 502: {
              window.location.replace(this.APP_SAML_URL + '/fault?errorCode=2&source=o');
            }
              break;
            default: {
              const locationHeader = error.response.headers['location'];
              console.log("attempts terminated response Location:" + locationHeader);
              if (locationHeader)
                window.location.replace(locationHeader);
              else
                window.location.replace(this.APP_SAML_URL + '/fault?errorCode=3&source=o');
            }

          }


        })
        .finally(() => this.loading = false)
    },
    setSpidLevel(spidLevel) {
      store.dispatch('setSpidLevel', {
        spidLevel: spidLevel
      });
    },
    setSpName(spName) {
      store.dispatch('setSpName', {
        spName: spName
      });
    },
    setProfile(profile) {
      store.dispatch('setProfile', {
        profile: profile || ""
      });
    },
    getParam(name) {
      let urlParams = new URLSearchParams(window.location.search);
      let myParam = urlParams.get(name);
      return myParam;
    },
    handleErrorEvent(outputData) {
      console.error('Error:' + JSON.stringify(outputData.detail));
      this.errored = true;
    },
    handleMessageEvent(inputData, outputData) {
      this.errored = false;
      console.log('handleMessageEvent:' + JSON.stringify(outputData.detail));
      if (outputData.detail.status === 200 && outputData.detail.operation === "login") {
        console.log("event detail2: " + inputData);
        this.$router.replace('/smsauth');
      }
      if (outputData.detail.status === 200 && outputData.detail.operation === "otpbysms") {
        console.log("event detail ok otp: " + inputData);
        this.$router.replace('/consent');
      }
    },
    logOut() {
      this.$store.dispatch('auth/logout');
      this.$router.replace('/login');
    },
    getSPData(transactionId) {
      AuthService.getSPData(transactionId).then(response => {
        this.info = response.data;
      }).catch(error => {
        console.log('error:' + JSON.stringify(error));
        this.$router.replace('/error');
      })
        .finally(() => (this.loading = false));
    }
  }
}
</script>


<style scoped>
.ic1-header-logo-new {
  background-image: url("./assets/logo-infocert-positivo-no-border.svg") !important;
  background-repeat: no-repeat;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  height: 2.5rem;
  width: 5.6rem;
}
</style>
